import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import MachineDetail from "@/pages/MachineDetail";
import CategoryLanding from "@/pages/CategoryLanding";

// Resolves /:section/:slug to either a Category landing page or a Machine detail page.
export default function SlugRouter({ listingType, categoryType, basePath }) {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, category: null });

  useEffect(() => {
    let active = true;
    setState({ loading: true, category: null });
    api.get(`/categories/slug/${slug}`)
      .then((r) => { if (active) setState({ loading: false, category: (r.data.type || "machine") === categoryType ? r.data : null }); })
      .catch(() => { if (active) setState({ loading: false, category: null }); });
    return () => { active = false; };
  }, [slug, categoryType]);

  if (state.loading) {
    return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-slate-400" /></div>;
  }
  if (state.category) {
    return <CategoryLanding category={state.category} listingType={listingType} basePath={basePath} />;
  }
  return <MachineDetail />;
}
